/* This is the EMIS School Area components */

<template>
  <v-container>
    <div>
      <span v-html="title"></span>
    </div>
    <div>
      <table
        style="height: 43px"
        width="500px;"
        border="1px;"
        cellspacing="0px;"
      >
        <tbody>
          <tr>
            <td
              style="
                width: 300px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              ប្រភេទ
            </td>
            <td class="data-row">បណ្ដោយ</td>
            <td class="data-row">ទទឹង</td>
            <td class="data-row">(គិតជា ម<sup>២</sup>)</td>
          </tr>
          <tr v-for="(value, row) in e11.length" :key="row">
            <td
              style="
                width: 300px;
                height: 25px;
                text-align: left;
                vertical-align: middle;
              "
            >
              {{ e11[row] }}
            </td>
            <td
              v-for="(value, col) in data[row].dt.length"
              :key="col"
              :class="[!e11OnOff[row][col] ? 'row-data-gray' : 'row-data']"
            >
              <numberinput
                v-model="data[row].dt[col]"
                :disabled="!e11OnOff[row][col]"
                class="number"
              />
            </td>
            <!--
            <td>
              <numberinput v-model="data[row][0]" class="number" />
            </td>
            -->
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import { e11, e11OnOff } from "@/utils/priascf/commonVariables.js";
import NumberInput from "@/components/common/NumberInput.vue";
export default {
  props: ["data", "title"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {
      e11: e11,
      e11OnOff: e11OnOff
    };
  },
};
</script>
<style scoped>
.number {
  width: 80px;
  text-align: center;
}
.row-data {
  width: 80px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
.row-data-gray {
  width: 60px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
  background-color: lightgray;
}
</style>